import React from "react"
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

export default () => {
  const { isPending, data: { schedule: { weeks, missing_slugs } = {} } = {} } = useQuery({
    queryKey: ['dodones_resolver', 'day'],
    queryFn: async () => {
      const response = await axios.get(`/api/dodones_resolver/day.json`);
      return response.data;
    }
  })

  if(isPending) return <div> Loading </div>

  return <>
           <div className='fcol'>
             {
               Object.entries(weeks).map(([index, week]) => {
                 return <Week key={ index } week={ week } />
               })
             }
           </div>
           <div>
             {
               missing_slugs.length == 0 ? null :
                 <>
                   <div className="text-red-500"> Missing Slugs: </div>
                   {
                     Object.entries(missing_slugs).map(([index, missing_slug]) => {
                       return <div key={ index }> { missing_slug } </div>
                     })
                   }
                 </>
             }
           </div>
         </>
}


const Week = ({ week }) => {
  return <div className="frow mb-d">
           {
             Object.entries(week).map(([index, weekDay]) => {
               return <WeekDay key={ index } weekDay={ weekDay } />
             })
           }
         </div>;
}

const WeekDay = ({ weekDay }) => {
  return <div className="fcol flex-1 p-d">
           <div> { weekDay.day } ( { weekDay.cycle_day_number } ) </div>
           {
             Object.entries(weekDay.dodones_attributes).map(([index, dodone_attributes]) => {
               return <div className="text-xs" key={ index }>{ dodone_attributes.slug }</div>;
             })
           }
         </div>;
}
